module.exports = new Promise(resolve => {
    const remoteUrl = (window.runtimeConfig?.BUILD_SURVEY_BASE_URL || 'undefined') + '/remoteEntry.js'
    console.log(remoteUrl)
    const script = document.createElement('script')
    script.src = remoteUrl
    script.onload = () => {
      const proxy = {
        get: (request) => window.survey.get(request),
        init: (arg) => {
          try {
            return window.survey.init(arg)
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      }
      resolve(proxy)
    }
    script.onerror = (error) => {
      console.error('error loading remote container')
      const proxy = {
        get: (request) => {
          // The remote could not be fetched. Hand back a component that renders
          // nothing, tagged so the host can detect it by reading the flag —
          // calling the component to probe it would run the remote's hooks
          // inside the host's fiber.
          const RemoteUnavailable = () => null
          RemoteUnavailable.remoteUnavailable = true
          return Promise.resolve(() => RemoteUnavailable);
        },
        init: (arg) => {
          return;
        }
      }
      resolve(proxy)
    }    
    document.head.appendChild(script);
  });